// extracted by mini-css-extract-plugin
export default {"content":"styles_content__eDQnZ","fullView":"styles_fullView__pHAxZ","shimmer":"styles_shimmer__iJQV4"};